module.exports = __webpack_public_path__ + "img/duuae_portrait.0f3d2f64.jpg";